export const PROCESSING = 'processing'
export const REGISTERED = 'registered'
export const ARCHIVE = 'archive'
export const FAILED = 'failed'

export function isPartProcessing(partRevision) {
    return (
        partRevision?.status === PROCESSING ||
        partRevision?.status === REGISTERED
    )
}
